import React from "react";
import PropTypes from "prop-types";

import Footer from "../Footer";
import EupagoPending from "./EupagoPending";

import OrderSummary from "components/OrderSummary";
import StyledTextField from "ui/StyledComponents/StyledTextField";

import mbwayIconDefault from "assets/images/mbwayIcon.png";
import mbwayIconInverted from "assets/images/mbwayIcon-inverted.png";

import { t } from "i18n/index";
import BizumPending from "./BizumPending";

const EupagoPaymentForm = ({
  items,
  userPhone,
  onUserPhoneChange,
  onSubmit,
  processingEupago,
  isBizumOrganization,
  redirectUrl
}) => {

  const primaryTextColor = getComputedStyle(document.documentElement).getPropertyValue('--primaryTextColor');
  const darkTheme = primaryTextColor === 'white';

  const payment_method = isBizumOrganization ? "bizum" : "mbway";

  const firstProduct = items[0]?.product;
  const frequency = items[0]?.frequency ?? "lifetime";
  const category = firstProduct?.category ?? "ticket";

  return (
      <form onSubmit={(e) => onSubmit(e, payment_method)} className="payment-form">
        { !processingEupago ? (
          <>
            {!isBizumOrganization &&
              <StyledTextField
                label={t("literal:phoneNumber")}
                name="userPhone"
                value={userPhone || ""}
                onChange={(event) => onUserPhoneChange(event.target.value)}
                fullWidth
                margin="normal"
                color="warning"
                autoFocus
                inputProps={{
                  maxLength: 9,
                  inputMode: "numeric",
                }}
                InputProps={{
                  endAdornment: <img src={darkTheme ? mbwayIconInverted : mbwayIconDefault} className="payment-method-button-icon" />,
                }}>
              </StyledTextField>}

            <OrderSummary
              items={items}
              frequency={frequency}
            />
          </>

          ) : (
            isBizumOrganization ? (
              <BizumPending redirectUrl={redirectUrl} category={category} />
            ) : (
              <EupagoPending category={category} />
            )
          )
        }

        <Footer
          itemPrice={firstProduct?.unit_price}
          object={firstProduct}
          caller={payment_method}
          processingEupago={processingEupago}
        />
      </form>
  );
};

EupagoPaymentForm.propTypes = {
  items: PropTypes.array.isRequired,
  userPhone: PropTypes.string,
  onUserPhoneChange: PropTypes.func,
  onSubmit: PropTypes.func,
  processingEupago: PropTypes.bool,
  isBizumOrganization: PropTypes.bool,
  redirectUrl: PropTypes.string,
};

export default EupagoPaymentForm;
